const LINK_ID = 'theme-preview-css';

// Appending the link at runtime guarantees it lands after both the app bundle
// CSS and the tenant theme <link> from the Blade template, so the preview wins
// the cascade by document order — the same rule the published theme relies on.
export const applyThemePreview = (url: string): void => {
    const existing = document.getElementById(LINK_ID);
    if (existing instanceof HTMLLinkElement) {
        if (existing.href !== url) {
            existing.href = url;
        }
        return;
    }

    const link = document.createElement('link');
    link.id = LINK_ID;
    link.rel = 'stylesheet';
    link.href = url;
    document.head.appendChild(link);
};

export const clearThemePreview = (): void => {
    document.getElementById(LINK_ID)?.remove();
};
